// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"mexico_Tooltip__1ViG6","Indicador":"mexico_Indicador__1u44Y","FadeIn":"mexico_FadeIn__32Lu7","fadeIn":"mexico_fadeIn__OYuPC"};